import type { StatusTone } from "@/components/status-badge"

export type OrderStatusBucket = "completed" | "inProgress" | "refused"

export const ORDER_STATUS_BUCKETS: OrderStatusBucket[] = [
  "inProgress",
  "completed",
  "refused",
]

export function bucketForOrderStatus(status?: string | null): OrderStatusBucket | null {
  if (!status) return null
  switch (status) {
    case "ORDER_COMPLETE":
    case "DELIVERED":
      return "completed"
    case "ORDER_REFUSED":
    case "CANCELLED":
      return "refused"
    case "ORDER_PLACED":
    case "ORDER_CONFIRMED_BY_SUPPLIER":
    case "IN_PREPARATION_AT_SUPPLIER":
    case "IN_TRANSIT_TO_ORIGIN_WAREHOUSE_FACTORY":
    case "AT_ORIGIN_WAREHOUSE_FACTORY":
    case "PLACED_AT_PORT_ON_SHIP":
    case "IN_MARITIME_TRANSIT":
    case "AT_DESTINATION_PORT":
    case "IN_TRANSIT_TO_FINAL_WAREHOUSE_FACTORY":
    case "IN_PROGRESS":
    case "PENDING":
    case "OPEN":
      return "inProgress"
    default:
      return "inProgress"
  }
}

export function bucketTone(bucket: OrderStatusBucket | null): StatusTone {
  switch (bucket) {
    case "completed":
      return "success"
    case "refused":
      return "danger"
    case "inProgress":
      return "info"
    default:
      return "muted"
  }
}
